<template>
  <div class="setting">
    <a-card title="全局设置">
      <a-form layout="inline">
        <a-alert message="Markdown模式: ![image](<url>), URL模式: <url>" show-icon></a-alert>
        <a-form-item label='链接复制格式'>
          <a-radio-group v-model="copyMode" :options="linkCopyType" default-value="md"/>
        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      linkCopyType: [
        { label: 'Markdown', value: 'md' },
        { label: 'URL', value: 'url' }
        ]
    }
  },
  computed: {
    copyMode: {
      get() {
        return this.$store.state.SettingModule.copyMode
      },
      set(v) {
        this.$store.commit('SettingModule/SET_COPY_MODE', v)
      }
    }
  }
}
</script>

<style scoped lang='scss'>

</style>